import debounce from '../../util/debounce';
const Header = {

    init() {
        this.jNavbar = $('.page__header');
        this.jScrollParent = $(window);
        this.currentScrollTop = 0;
        this.addEvents();
        this._checkAndAnimateHeader();
        this.homeHeader();
    },
    _onWindowResize: function() {
        if (window.innerWidth < 768) {
            $('.primary-nav__item-sub-menu').css('left', '');
        }
    },
    addEvents() {
        $('.jsPrimaryMenu .primary-nav__item').on('hover', $.proxy(this._onPrimaryMenuHover, this));
        $('.dropdown-menu').on('click', (e) => {
            e.stopPropagation();
        })
        this.addHeaderAutoHideEv();
        $(window).on('resize', debounce($.proxy(this._onWindowResize, this), 800));
    },
    addHeaderAutoHideEv() {
        this.jScrollParent.scroll(debounce($.proxy(this._checkAndAnimateHeader, this), 10));
    },
    _onPrimaryMenuHover(e) {

        if (window.innerWidth < 768) {
            return;
        }
        const jTarget = $(e.delegateTarget);
        const jSubmenu = jTarget.closest('.primary-nav__item').find('> .primary-nav__item-sub-menu');
        let maxWidth = 0; //this._jsCards.innerHeight();
        let jCurCol, jsCols = jSubmenu.find('.primary-nav__item-sub-menu-col');

        // Resize all the cols to same size
        for (let i = 0; i < jsCols.length; i++) {
            jCurCol = $(jsCols[i]);
            if (jCurCol.innerWidth() > maxWidth) {
                jCurCol.css('width', '');
                maxWidth = jCurCol.innerWidth();
            }
        }
        if (maxWidth == 0) {
            jsCols.css('width', '');
        } else {
            jsCols.css('width', maxWidth);
        }


        if (window.innerWidth < 1000) {
            jSubmenu.addClass('primary-nav__item-sub-menu_no-arrow');
            jSubmenu.css('left', 0);
        } else {
            jSubmenu.removeClass('primary-nav__item-sub-menu_no-arrow');
            jSubmenu.css('left', -(jSubmenu.innerWidth() / 2 - jTarget.width() / 2));
        }



    },
    _checkAndAnimateHeader() {
        const a = this.jScrollParent.scrollTop();
        this.currentScrollTop = a;
        if (this.currentScrollTop > 50) {
            this.jNavbar.addClass('page__header_up');
        } else {
            this.jNavbar.removeClass('page__header_up');
        }
        this.c = this.currentScrollTop;
    },

    homeHeader(){
        // const homeWindow = this.jScrollParent.scrollTop();
        // this.currentScrollTop = homeWindow;
        // if(this.currentScrollTop > 50){
        //     console.log('Scrolled 250');
        // }else{
        //     console.log('we are at top');
        // }
        // console.log(this.currentScrollTop = homeWindow)
        // console.log('succeed');
        $(window).on('scroll', function(){
            if($(window).scrollTop() > 250){                
                $('.page_home .header').addClass('home-header-active');
            }else{
                $('.page_home .header').removeClass('home-header-active');
            }
        })
    },
    
}
export default Header;


// WEBPACK FOOTER //
// ./scripts/modules/components/_header.js